// extracted by mini-css-extract-plugin
export default {"Testimonial":"Testimonial_Testimonial__3gfpD","Image":"Testimonial_Image__PMtMZ","Text":"Testimonial_Text__8ADSE"};